import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import styled from '@mui/material/styles/styled';

export const ContainerPeriod = styled(Box)`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding-left: 4px;
  padding-right: 4px;
  height: 32px;
  max-width: fit-content;
`;

export const StyledIconButton = styled(IconButton)<{
  selected?: boolean;
}>`
  border-radius: 0;
  padding-left: 8px;
  padding-right: 8px;
  height: 32px;

  border-bottom: ${(props) => (props.selected ? `2px solid #14AE5C` : 'none')};
  padding-bottom: ${(props) => (props.selected ? '6px' : undefined)};
  color: inherit;
  p {
    font-weight: ${(props) => (props.selected ? 700 : 400)};
  }
`;
